const state = {
  GoodsItems: [],
  DeliveryAddress: '',
  IsFromShoppingCart: false
}

// getters
const getters = {
  // 可返回购物的总金额
  CartTotalPrice: (state, getters) => {
    return getters.CartProducts.reduce((total, product) => {
      return (total = total + product.quantity * product.price)
    }, 0)
  },

  // 可返回购物的非特价商品总金额
  CartNotSpecialDiscountTotalPrice: (state, getters) => {
    return getters.CartProducts.reduce((total, product) => {
      if (product.specialdiscount === 0 || product.specialdiscount === 100) {
        total = total + product.quantity * product.price
      }
      return total
    }, 0)
  },

  // 可返回商品的总重量
  CartTotalWeight: (state, getters) => {
    return getters.CartProducts.reduce((total, product) => {
      total = total + product.quantity * product.weight
      return total
    }, 0)
  },

  // 可返回商品的总数量
  CartTotalQuantity: (state, getters) => {
    return getters.CartProducts.reduce((total, product) => {
      total = total + product.quantity
      return total
    }, 0)
  },

  CartProducts: state => {
    return state.GoodsItems.map(item => {
      return {
        id: item.id,
        goodsname: item.goodsname,
        price: item.price,
        quantity: item.quantity,
        srcimg: item.srcimg,
        weight: item.weight,
        specialdiscount: item.specialdiscount
      }
    })
  },
  GetItems: (state, getters) => {
    return state.GoodsItems
  },
  GetDeliveryAddress: (state, getters) => {
    return state.DeliveryAddress
  }
}

// actions
const actions = {
  // 下单，清空购物车
  ClearGoodsItems ({ commit }) {
    commit('ClearCartItems')
  },

  // 复制整个商品清单到Items
  CopyGoodsItems ({ commit }, items) {
    commit('SetCartItems', { items })
  },

  // 从购物车减去商品
  DeleteProductFromCart ({ state, commit }, product) {
    const cartItem = state.GoodsItems.find(item => item.id === product.id)

    if (cartItem && cartItem.quantity > 1) {
      commit('MinusItemQuantity', product)
    } else {
      state.GoodsItems.splice(state.GoodsItems.indexOf(cartItem), 1)
      // state.GoodsItems.pop(cartItem) // 再减1 就清空
    }
  },
  // 往购物车添加商品
  AddProductToCart ({ state, commit }, product) {
    // 'id':        this.GetGoods_ID,
    // 'goodsname': this.GetGoodsName,
    // 'price':     this.GetUserGradePrice,
    // 'weight':    this.GetWeight,
    // 'srcimg':    this.GetSrcImg,
    // 'quantity':  1
    // 'specialdiscount': this.SpecialDiscount

    if (state.GoodsItems.length <= 0) {
      commit('PushProductToCart', product)
    } else {
      const cartItem = state.GoodsItems.find(item => item.id === product.id)
      if (!cartItem) {
        commit('PushProductToCart', product)
      } else {
        commit('IncrementItemQuantity', product)
      }
    }
  },

  ModifyDeliveryAddress ({ state, commit }, aDeliveryAddress) {
    commit('SetDeliveryAddress', aDeliveryAddress)
  },

  ModifyIsFromShoppingCart ({ state, commit }, aIsFromShoppingCart) {
    commit('SetIsFromShoppingCart', aIsFromShoppingCart)
  }
}

// mutations
const mutations = {
  PushProductToCart (state, product) {
    state.GoodsItems.push(product)
  },

  IncrementItemQuantity (state, product) {
    const cartItem = state.GoodsItems.find(item => item.id === product.id)
    cartItem.quantity = cartItem.quantity + product.quantity // product.quantity = 1  由调用端赋值为1
  },

  MinusItemQuantity (state, product) {
    const cartItem = state.GoodsItems.find(item => item.id === product.id) // product.quantity = 1 由调用端赋值为1
    cartItem.quantity = cartItem.quantity - product.quantity
  },

  SetCartItems (state, { items }) {
    state.GoodsItems = items
  },

  ClearCartItems (state) {
    state.GoodsItems.splice(0, state.GoodsItems.length)
    state.GoodsItems = []
  },

  SetDeliveryAddress (state, aDeliveryAddress) {
    state.DeliveryAddress = aDeliveryAddress
  },

  SetIsFromShoppingCart (state, aIsFromShoppingCart) {
    state.IsFromShoppingCart = aIsFromShoppingCart
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ShoppingData.js